/* eslint-disable */
import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { NOTIFICATION_AND_CMS_URL } from "../../Shared/constant";
import Form from "react-bootstrap/Form";
import EmptySpaceFieldValid from "../../Common/EmptySpaceFieldValid";
import CheckValid from "../../Common/CheckValid";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CommonScrollBar from "../../Common/CommonScrollBar";
import UploadFileIcon from "../../../assets/img/Upload-File.svg";
import DeleteIcon from "../../../assets/img/remove_file.svg";
import CommonToggle from "../../Common/CommonToggle";
import UploadFileAPI from "../../../Api/UploadFileAPI";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import wsSend_request from "../../../Api/ws/ws_request";
import { WebSocketContext } from "../../../App";
import CommonDateTime from "../../Common/CommonDateTime";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import CommonReactSelectMenu from "../../Common/CommonReactSelectMenu";

const CreateNotificationAndCMS = () => {
    const { roomtype, roomId } = useParams();
    const CurrentLocation = useLocation().pathname.split("/")[1];
    const Navigate = useNavigate();
    const { websocket } = useContext(WebSocketContext);
    const { accessToken, ClearFormSet, device_id, CustomNotificationsListing, CampaignsNotificationsListing, NetPromoterScoreNotificationsListing, AllMarketCampaignsListing } = useSelector((state) => state.adminReducers);
    const RoomTypeTabs = roomtype?.replace(/-/g, " ")?.toLowerCase()?.replace(/\b\w/g, (c) => c.toUpperCase());
    const optionsCampaign = AllMarketCampaignsListing?.filter((elm) => elm?.status === true)?.map((item, index)=>({key:item.id, value:item?.id , label:item?.card_title }));

    // Normal State
    const today = new Date();
    const [ Box, setBox ] = useState("");
    const [ LoaderFile, setLoaderFile ] = useState(false);
    const [ NotificationState, setNotificationState ] = useState({
        Title: "",
        Description: "",
        StartDate: "",
        EndDate: "",
        UploadedImage: "",
        UploadedImageName: "",
        Status: true,
        NpsUrl: "",
    });
    const [ Campaigns, setCampaigns ] = useState("");
    const [ FrequencyState, setFrequencyState ] = useState([
        {
            frequency_id: 1,
            frequency_name: "Daily",
            isChecked: false,
            frequency_attempts: 1,
            times_isAllow: true,
            date_isAllow: false,
            frequency_times: [{ id: 1, time: "" }],
            day_month_isAllow: false,
        },
        {
            frequency_id: 2,
            frequency_name: "Weekly",
            isChecked: false,
            frequency_attempts: 1,
            frequency_days: [ 
                { day_name: "Monday", short_day_name: "Mon", isChecked: false },
                { day_name: "Tuesday", short_day_name: "Tue", isChecked: false },
                { day_name: "Wednesday", short_day_name: "Wed", isChecked: false },
                { day_name: "Thursday", short_day_name: "Thu", isChecked: false },
                { day_name: "Friday", short_day_name: "Fri", isChecked: false },
                { day_name: "Saturday", short_day_name: "Sat", isChecked: false },
                { day_name: "Sunday", short_day_name: "Sun", isChecked: false },
            ],
            times_isAllow: true,
            date_isAllow: false,
            frequency_times: [{ id: 1, time: "" }],
            day_month_isAllow: false,
        },
        {
            frequency_id: 3,
            frequency_name: "Monthly",
            isChecked: false,
            frequency_attempts: 1,
            times_isAllow: true,
            date_isAllow: false,
            frequency_times: [{ id: 1, time: "" }],
            day_month_isAllow: true,
            day_of_month: "",
        },
        {
            frequency_id: 4,
            frequency_name: "Quarterly",
            isChecked: false,
            frequency_attempts: 1,
            times_isAllow: true,
            date_isAllow: true,
            frequency_times: [{ id: 1, time: "" }],
            frequency_dates: [{ id: 1, date: "" }],
            day_month_isAllow: false,
        },
        {
            frequency_id: 5,
            frequency_name: "Custom",
            isChecked: false,
            frequency_attempts: 1,
            times_isAllow: true,
            date_isAllow: true,
            frequency_times: [{ id: 1, time: "" }],
            frequency_dates: [{ id: 1, date: "" }],
            day_month_isAllow: false,
        }
    ]);
    const exceptThisCostSymbols = ["e", "E", "+", "-", "."];

    // ERROR STATES
    const [ errorTitle, seterrorTitle ] = useState("");
    const [ errorDescription, seterrorDescription ] = useState(""); 
    const [ errorStartDate, seterrorStartDate ] = useState("");
    const [ errorEndDate, seterrorEndDate ] = useState("");
    const [ errorUploadedImage, seterrorUploadedImage ] = useState("");
    const [ errorNpsUrl, seterrorNpsUrl ] = useState("");
    const [ errorNotificationFrequency, seterrorNotificationFrequency ] = useState("");
    const [ errorCampaign, seterrorCampaign ] = useState("");

    // ON PAGE LOAD SET THE SELECTED BOX
    useEffect(() => {
        if(RoomTypeTabs === "Custom Notification") {
            setBox("Custom Notification");
        } else if(RoomTypeTabs === "Net Promoter Score") {
            setBox("NPS");
        } else if(RoomTypeTabs === "Campaign") {
            setBox("CAMPAIGN");
        };
    }, []);
    
    let CurrentData_;  
    if(RoomTypeTabs === "Custom Notification") {
        CurrentData_ = CustomNotificationsListing?.list?.filter((elm) => elm?.id === roomId)[0];
    } else if(RoomTypeTabs === "Net Promoter Score") {
        CurrentData_ = NetPromoterScoreNotificationsListing?.list?.filter((elm) => elm?.id === roomId)[0];
    } else if(RoomTypeTabs === "Campaign") {
        CurrentData_ = CampaignsNotificationsListing?.list?.filter((elm) => elm?.id === roomId)[0];
    };

    useEffect(() => {
        if(Box === "CAMPAIGN") {
            let param = { 
                "transmit": "broadcast", 
                "url": "list_marketing_campaign",
                "request" : { 
                    "status" : true, 
                    "limit" : 5000,
                    "page_no" : 1, 
                    "order_by": "-updated_at",
                },
                "DeviceId" : device_id
            };
            wsSend_request(websocket, param);
        };
    }, [ Box ]);

    useEffect(() => {
        if(CurrentLocation === "edit-notifications-and-cms") {
            const CurrentCampaign = optionsCampaign?.filter((elm) => elm?.value === CurrentData_?.campaign_id)[0];
            setNotificationState({
                ...NotificationState,
                Title: CurrentData_?.cms_title,
                Description: CurrentData_?.cms_description,
                StartDate: new Date(CurrentData_?.cms_start_date),
                EndDate: new Date(CurrentData_?.cms_end_date),
                UploadedImage: CurrentData_?.label_image === null ? "" : CurrentData_?.label_image,
                UploadedImageName: CurrentData_?.label_image_name === null ? "" : CurrentData_?.label_image_name,
                Status: CurrentData_?.cms_status,
                NpsUrl: CurrentData_?.nps_url,
            });
            setCampaigns(CurrentCampaign);

            const updatedFrequencyState = FrequencyState.map((freq) => {
                if (freq.frequency_name.toLowerCase() === CurrentData_?.cms_frequency_type) {
                    return {
                        ...freq,
                        isChecked: true,
                        frequency_attempts: CurrentData_?.cms_frequency_attempts,
                        day_of_month: CurrentData_?.cms_frequency_data?.day_of_month
                            ? parseInt(CurrentData_?.cms_frequency_data?.day_of_month, 10)
                            : "",
                        frequency_times: freq.times_isAllow? 
                            freq.frequency_name === "Daily"
                            ? CurrentData_?.cms_frequency_data?.times_per_day?.map((time, index) => ({
                                id: index + 1,
                                time: time,
                            })) : (freq.frequency_name === "Monthly" || freq.frequency_name === "Quarterly")
                            ? CurrentData_?.cms_frequency_data?.times?.map((time, index) => ({
                                id: index + 1,
                                time: time,
                            })) : freq.frequency_name === "Custom"  
                            ? CurrentData_?.cms_frequency_data?.custom_times?.map((time, index) => ({
                                id: index + 1,
                                time: time,
                            })) : CurrentData_?.cms_frequency_data?.times?.map((time, index) => ({
                                id: index + 1,
                                time: time,
                            }))
                            : freq.frequency_times,

                        frequency_dates: freq.date_isAllow
                            ? freq.frequency_name === "Quarterly" && CurrentData_?.cms_frequency_data?.months_of_year?.[0] ? [
                                  {
                                      id: 1,
                                      date: moment(
                                          `${CurrentData_?.cms_frequency_data?.months_of_year?.[0]} ${CurrentData_?.cms_frequency_data?.day_of_month}`,
                                          "MMM DD"
                                      ).toDate(),
                                  },
                            ] : CurrentData_?.cms_frequency_data?.custom_dates?.map((date, index) => ({
                                      id: index + 1,
                                      date: moment(date, "YYYY-MM-DD").toDate(),
                                  }))
                            : freq.frequency_dates,
                        frequency_days: freq.frequency_name === "Weekly"
                            ? freq.frequency_days.map((day) => ({
                                    ...day,
                                    isChecked: CurrentData_?.cms_frequency_data?.days_of_week?.includes(day.short_day_name),
                                }))
                            : freq.frequency_days,
                    };
                };
                return {
                    ...freq,
                    isChecked: false,
                    frequency_attempts: 1,
                    frequency_times: [{ id: 1, time: "" }],
                    frequency_dates: [{ id: 1, date: "" }],
                    frequency_days: freq.frequency_name === "Weekly"
                        ? freq.frequency_days.map((day) => ({ ...day, isChecked: false }))
                        : [],
                };
            });
            setFrequencyState(updatedFrequencyState);
        };
    }, [ CurrentData_ ]);

    // UPDATE ONCHANGE FREQUENCY WISE TIME AND DATE
    const onChangeUpdatedFrequency = (frequencyId, value) => {
        const updatedFrequency = FrequencyState.map((freq) => {
            if (freq.frequency_id === frequencyId) {
                if(freq.frequency_name === "Custom") {
                    // UPDATE TIME
                    const updatedTimes = Array.from({ length: parseInt(value)}, (_, index) => ({
                        id: index + 1,
                        time: "",
                    }));
                    updatedTimes.forEach(item1 => {
                        let item2 = freq.frequency_times.find(item => item.id === item1.id);
                        if (item2) {
                            item1.time = item2.time;
                        }
                    });

                    // UPDATE DATE
                    const updatedDates = Array.from({ length: parseInt(value)}, (_, index) => ({
                        id: index + 1,
                        date: "",
                    }));
                    updatedDates.forEach(item1 => {
                        let item2 = freq.frequency_dates.find(item => item.id === item1.id);
                        if (item2) {
                            item1.date = item2.date;
                        }
                    });

                    return { ...freq, 
                        frequency_attempts: value, 
                        frequency_times: updatedTimes, 
                        frequency_dates: updatedDates 
                    };
                } else {
                    if(freq.times_isAllow) {
                        // UPDATE TIME
                        const updatedTimes = Array.from({ length: parseInt(value)}, (_, index) => ({
                            id: index + 1,
                            time: "",
                        }));
                        
                        updatedTimes.forEach(item1 => {
                            let item2 = freq.frequency_times.find(item => item.id === item1.id);
                            if (item2) {
                                item1.time = item2.time;
                            }
                        });
                        return { ...freq, frequency_attempts: value, frequency_times: updatedTimes };
                    } else if(freq.date_isAllow) {
                        // UPDATE DATE
                        const updatedDates = Array.from({ length: parseInt(value)}, (_, index) => ({    
                            id: index + 1,
                            date: "",   
                        }));

                        updatedDates.forEach(item1 => {
                            let item2 = freq.frequency_dates.find(item => item.id === item1.id);
                            if (item2) {
                                item1.date = item2.date;
                            }
                        });
                        return { ...freq, frequency_attempts: value, frequency_dates: updatedDates };       
                    } else {
                        return { ...freq, frequency_attempts: value };
                    };
                };
            };
            return freq;
        });
        setFrequencyState(updatedFrequency);
    };

    // SELECT START DATE
    const DateStartGet = (date) => {
        ClearFrequency();
        if (date === null) {
            setNotificationState({
                ...NotificationState,
                StartDate: "",
                EndDate: "",
            });
            CheckValid((date === null || date === "") ? "" : date, { type: 'NotificationStartDate', error: seterrorStartDate });
        } else {
            setNotificationState({
                ...NotificationState,
                StartDate: date,
                EndDate: "",
            });
            CheckValid(date, { type: 'NotificationStartDate', error: seterrorStartDate });
        };
    };

    // SELECT END DATE
    const DateEndGet = (date) => {
        if (date === null) {
            setNotificationState({
                ...NotificationState,
                EndDate: "",
            });
            CheckValid(date === null ? "" : date, { type: 'NotificationEndDate', error: seterrorEndDate });
        } else {
            setNotificationState({
                ...NotificationState,
                EndDate: date,
            });
            CheckValid(date, { type: 'NotificationEndDate', error: seterrorEndDate });
        };
    };

    // UPLOAD IMAGE FUNCTION
    const UploadImage = async (e) => {
        const files = e.target.files[0];
        if (files) {
            setLoaderFile(true);
            const formDatas = new FormData();
            formDatas.append("file", files, files.name);
            const fileresponse = await UploadFileAPI(accessToken, formDatas);
            if (fileresponse?.status === 200) {
                setNotificationState({
                    ...NotificationState,
                    UploadedImage: fileresponse?.id,
                    UploadedImageName: fileresponse?.name
                });
                
                CheckValid(fileresponse, { type: 'NotificationUploadedImage', error: seterrorUploadedImage });
                
                setTimeout(() => {
                    setLoaderFile(false);
                }, 1000);
                document.getElementById('fileInput').value = null;
            } else {
                setLoaderFile(false);
                setNotificationState({
                    ...NotificationState,
                    UploadedImage: "",
                    UploadedImageName: "",
                });
                
                CheckValid("", { type: 'NotificationUploadedImage', error: seterrorUploadedImage });
            };
        };
    };

    const FrequencyStateIsValid = FrequencyState?.filter((elm) => {
        if(elm?.isChecked && elm?.frequency_attempts !== "") {
            const CheckFrequencyTimes = elm?.frequency_times?.every((time) => time?.time !== "" && time?.time !== null);
            const CheckFrequencyDates = elm?.frequency_dates?.every((time) => time?.date !== "" && time?.date !== null);
            const CheckFrequencyDays = elm?.frequency_days?.filter((time) => time.isChecked === true)?.length > 0;

            if(elm?.frequency_name === "Daily") {
                if (CheckFrequencyTimes) {
                    return true;
                };
            } else if(elm?.frequency_name === "Weekly") {
                if(CheckFrequencyDays && CheckFrequencyTimes) {
                    return true;
                };
            } else if(elm?.frequency_name === "Monthly") {
                if((elm?.day_of_month !== "" && elm?.day_of_month !== null) && CheckFrequencyTimes) {
                    return true;
                };
            } else if(elm?.frequency_name === "Quarterly") {
                if(CheckFrequencyDates && CheckFrequencyTimes) {
                    return true;
                };
            } else if(elm?.frequency_name === "Custom") {
                if (CheckFrequencyTimes && CheckFrequencyDates) {
                    return true;
                };
            } else {
                return false;
            };
        };
    })?.length > 0;

    // CREATE NOTIFICATIONS AND CMS FUNCTION
    const CreateNotificationsCMS = () => {
        let CustomerValidations;
        if(Box !== "") {
            if(Box === "Custom Notification") {
                CustomerValidations = NotificationState?.Title !== "" && NotificationState?.Description !== "" && NotificationState?.StartDate !== "" && NotificationState?.EndDate !== "" && NotificationState?.UploadedImage !== "" && FrequencyStateIsValid;
            } else if(Box === "CAMPAIGN") {
                CustomerValidations = NotificationState?.Title !== "" && NotificationState?.Description !== "" && NotificationState?.StartDate !== "" && NotificationState?.EndDate !== "" && NotificationState?.UploadedImage !== "" && Campaigns !== "" && FrequencyStateIsValid;
            } else if(Box === "NPS") {
                CustomerValidations = NotificationState?.Title !== "" && NotificationState?.Description !== "" && NotificationState?.StartDate !== "" && NotificationState?.EndDate !== "" && NotificationState?.UploadedImage !== "" && NotificationState?.NpsUrl !== "" && FrequencyStateIsValid;
            }
        };

        if(CustomerValidations) {
            const CurrentFrequency = FrequencyState?.filter((item) => item?.isChecked === true)[0];
            const { frequency_name, frequency_times, frequency_days, frequency_attempts, frequency_dates, day_of_month } = CurrentFrequency;

            let param = { 
                "transmit": "broadcast", 
                "url": CurrentLocation === "edit-notifications-and-cms" ? "update_cms_notification" : "add_cms_notification",
                "request" : { 
                    "cms_type": Box,
                    "cms_title": NotificationState?.Title,
                    "cms_description": NotificationState?.Description,
                    "cms_start_date": CommonDateTime(NotificationState?.StartDate, "YYYY-MM-DD", "hide"),
                    "cms_end_date": CommonDateTime(NotificationState?.EndDate, "YYYY-MM-DD", "hide"),
                    "cms_frequency_type": frequency_name?.toLocaleLowerCase(),
                    "cms_frequency_data": "",
                    "cms_frequency_attempts": frequency_attempts,
                    "cms_status": NotificationState?.Status,
                    "label_image": NotificationState?.UploadedImage
                },
                "DeviceId" : device_id
            };

            if(Box === "NPS") {
                param.request.nps_url = NotificationState?.NpsUrl;
            };

            if(Box === "CAMPAIGN") {
                param.request.campaign_id = Campaigns?.value;
            };

            if(CurrentLocation === "edit-notifications-and-cms") {
                param.request.cms_id = roomId;
            };

            if(frequency_name === "Daily") {
                const ConvertTime = frequency_times?.map((item) => item?.time);
                param.request.cms_frequency_data = { times_per_day: ConvertTime };
            } else if(frequency_name === "Weekly") {
                const ConvertTime = frequency_times?.map((item) => item?.time);
                const ConvertDays = frequency_days?.filter((item) => item?.isChecked === true)?.map((item) => item?.short_day_name);
                param.request.cms_frequency_data = { times: ConvertTime, days_of_week: ConvertDays };
            } else if(frequency_name === "Monthly") {
                const ConvertTime = frequency_times?.map((item) => item?.time);
                param.request.cms_frequency_data = { times: ConvertTime, day_of_month: day_of_month };
            } else if(frequency_name === "Quarterly") {
                const ConvertTime = frequency_times?.map((item) => item?.time);
                const dateQuarterly = moment(frequency_dates[0]?.date).format("DD");
                const ConvertDays = [];
                for (let i = 0; i <= 90; i += 30) {
                    const month = moment(frequency_dates[0]?.date)
                        .add(i, 'days')
                        .format("MMM");

                    if (!ConvertDays.includes(month)) {
                        ConvertDays.push(month);
                    };
                };
                param.request.cms_frequency_data = { times: ConvertTime, months_of_year: ConvertDays, day_of_month: dateQuarterly };
            } else if(frequency_name === "Custom") {
                const ConvertTime = frequency_times?.map((item) => item?.time);
                const ConvertDates = frequency_dates?.map((item) => moment(item?.date).format("YYYY-MM-DD"));
                param.request.cms_frequency_data = { custom_times: ConvertTime, custom_dates: ConvertDates };
            };
            seterrorNotificationFrequency("");
            seterrorCampaign("");
            wsSend_request(websocket, param);
        } else {
            CheckValid(NotificationState?.Title, { type: 'NotificationTitle', error: seterrorTitle });
            CheckValid(NotificationState?.Description, { type: 'NotificationDescription', error: seterrorDescription });
            CheckValid(NotificationState?.StartDate, { type: 'NotificationStartDate', error: seterrorStartDate });
            CheckValid(NotificationState?.EndDate, { type: 'NotificationEndDate', error: seterrorEndDate });
            CheckValid(NotificationState?.UploadedImage, { type: 'NotificationUploadedImage', error: seterrorUploadedImage });
            CheckValid(NotificationState?.NpsUrl, { type: 'NotificationNpsUrl', error: seterrorNpsUrl });

            if(FrequencyStateIsValid) {
                seterrorNotificationFrequency("");
            } else {
                seterrorNotificationFrequency("Notification frequency cannot be empty");
            };

            if(Campaigns) {
                seterrorCampaign("");
            } else {
                seterrorCampaign("Please select Campaign");
            };
        }
    };

    // CLEAR FREQUENCY
    const ClearFrequency = () => {
        setFrequencyState([
            {
                frequency_id: 1,
                frequency_name: "Daily",
                isChecked: false,
                frequency_attempts: 1,
                times_isAllow: true,
                date_isAllow: false,
                frequency_times: [{ id: 1, time: "" }],
                day_month_isAllow: false,
            },
            {
                frequency_id: 2,
                frequency_name: "Weekly",
                isChecked: false,
                frequency_attempts: 1,
                frequency_days: [ 
                    { day_name: "Monday", short_day_name: "Mon", isChecked: false },
                    { day_name: "Tuesday", short_day_name: "Tue", isChecked: false },
                    { day_name: "Wednesday", short_day_name: "Wed", isChecked: false },
                    { day_name: "Thursday", short_day_name: "Thu", isChecked: false },
                    { day_name: "Friday", short_day_name: "Fri", isChecked: false },
                    { day_name: "Saturday", short_day_name: "Sat", isChecked: false },
                    { day_name: "Sunday", short_day_name: "Sun", isChecked: false },
                ],
                times_isAllow: true,
                date_isAllow: false,
                frequency_times: [{ id: 1, time: "" }],
                day_month_isAllow: false,
            },
            {
                frequency_id: 3,
                frequency_name: "Monthly",
                isChecked: false,
                frequency_attempts: 1,
                times_isAllow: true,
                date_isAllow: false,
                frequency_times: [{ id: 1, time: "" }],
                day_month_isAllow: true,
                day_of_month: "",
            },
            {
                frequency_id: 4,
                frequency_name: "Quarterly",
                isChecked: false,
                frequency_attempts: 1,
                times_isAllow: true,
                date_isAllow: true,
                frequency_times: [{ id: 1, time: "" }],
                frequency_dates: [{ id: 1, date: "" }],
                day_month_isAllow: false,
            },
            {
                frequency_id: 5,
                frequency_name: "Custom",
                isChecked: false,
                frequency_attempts: 1,
                times_isAllow: true,
                date_isAllow: true,
                frequency_times: [{ id: 1, time: "" }],
                frequency_dates: [{ id: 1, date: "" }],
                day_month_isAllow: false,
            }
        ]);
    };

    useEffect(() => {
        if(ClearFormSet?.action === 200 && (ClearFormSet?.url === "add_cms_notification" || ClearFormSet?.url === "update_cms_notification")) {
            Navigate(NOTIFICATION_AND_CMS_URL);
        };
    }, [ ClearFormSet ]);

    document.addEventListener("wheel", function (event) {
        if (document.activeElement.type === "number" && document.activeElement.classList.contains("inputBoxs")) {
            document.activeElement.blur();
        }
    });

    return(<section className="createApplcation_wrapper">
        <div className="MainHeader">
            <h4>{CurrentLocation === "edit-notifications-and-cms" ? "Edit" : "Create"} Notification</h4>
            <Link to={NOTIFICATION_AND_CMS_URL} className="btn btn-link backbtn"><i className="bi bi-arrow-left-short"></i> Back</Link>
        </div>
        <div className="tabsWrappersmAN">
            <CommonScrollBar className="ScrollbarsSidebar" height={{ height: "calc(100vh - 135px)" }}>
                <div className="formloginset">
                    <div className="divider_forms">
                        <div className="row">
                            <div className="col-md-3">
                                <Form.Group className="mb-3 " >
                                    <Form.Label>Select Box</Form.Label>
                                    <select className="form-control" 
                                        value={Box} 
                                        onChange={(e) => setBox(e.target.value)}
                                    >
                                        <option value={""}>Select Box</option>
                                        <option value={"Custom Notification"}>Custom Notification</option>
                                        <option value={"NPS"}>NPS</option>
                                        <option value={"CAMPAIGN"}>Marketing Campaign</option>
                                    </select>
                                </Form.Group>
                            </div>
                        </div>
                    </div>
                    {Box !== "" && (<React.Fragment>
                        <div className="divider_forms">
                            <div className="row">
                                <div className="col-md-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Notification Title<span className="mendatory_star">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={NotificationState?.Title}
                                            onChange={(e) => setNotificationState({...NotificationState, Title: e.target.value})}
                                            onKeyUp={(e) => CheckValid(e.target.value, { type: 'NotificationTitle', error: seterrorTitle })}
                                            onKeyDown={EmptySpaceFieldValid} 
                                            placeholder="Enter Notification Title"
                                        />
                                        {errorTitle !== "" && (<span className="error_medotory">{errorTitle}</span>)}
                                    </Form.Group>
                                </div>
                                <div className="col-md-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Notification Description<span className="mendatory_star">*</span></Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            value={NotificationState?.Description}
                                            onChange={(e) => setNotificationState({...NotificationState, Description: e.target.value})}
                                            onKeyUp={(e) => CheckValid(e.target.value, { type: 'NotificationDescription', error: seterrorDescription })}
                                            onKeyDown={EmptySpaceFieldValid} 
                                            placeholder="Enter Notification Description"
                                        />
                                        {errorDescription !== "" && (<span className="error_medotory">{errorDescription}</span>)}
                                    </Form.Group>
                                </div>
                                {Box === "CAMPAIGN" && (<div className="col-md-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Select Campaign<span className="mendatory_star">*</span></Form.Label>
                                        <CommonReactSelectMenu 
                                            label={"Campaign"}
                                            options={optionsCampaign} 
                                            selectValue={Campaigns} 
                                            setSelectValue={setCampaigns} 
                                            dependantState={{
                                                allow: false,
                                            }} 
                                            isMendatory={true}
                                            errorState={errorCampaign}
                                            setErrorState={seterrorCampaign}
                                            isAllowClearable={true}
                                            customWidth={"100%"}
                                            customeHeight={"38px"}
                                            isMulti={false}
                                        />
                                    </Form.Group>
                                </div>)}
                                {Box === "NPS" && (<div className="col-md-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>NPS URL<span className="mendatory_star">*</span></Form.Label>
                                        <Form.Control   
                                            type="text"
                                            value={NotificationState?.NpsUrl}
                                            onChange={(e) => setNotificationState({...NotificationState, NpsUrl: e.target.value})}
                                            onKeyUp={(e) => CheckValid(e.target.value, { type: 'NotificationNpsUrl', error: seterrorNpsUrl })}
                                            onKeyDown={EmptySpaceFieldValid} 
                                            placeholder="Enter NPS URL"
                                        />
                                        {errorNpsUrl !== "" && (<span className="error_medotory">{errorNpsUrl}</span>)}
                                    </Form.Group>
                                </div>)}
                            </div>
                        </div>
                        <div className="divider_forms">
                            <div className="row">
                                <div className="col-md-3" >
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Start Date<span className="mendatory_star">*</span></Form.Label>
                                        <div className="datepickField min">
                                            <DatePicker
                                                selected={NotificationState?.StartDate}
                                                onChange={(date) => DateStartGet(date)}
                                                dateFormat="dd/MM/yyyy"
                                                minDate={today}
                                                placeholderText="Enter Start Date"
                                                isClearable={NotificationState?.StartDate ? true : false}
                                                autoComplete="off"
                                            />
                                        </div>
                                        {errorStartDate && (<small className="error_medotory">{errorStartDate}</small>)}
                                    </Form.Group>
                                </div>
                                <div className="col-md-3" >
                                    <Form.Group className="mb-3" >
                                        <Form.Label>End Date<span className="mendatory_star">*</span></Form.Label>
                                        <div className="datepickField">
                                            <DatePicker
                                                minDate={NotificationState?.StartDate}
                                                selected={NotificationState?.EndDate}
                                                onChange={(date) => DateEndGet(date)}
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Enter End Date"
                                                isClearable={NotificationState?.EndDate ? true : false}
                                                name="ToDate"
                                                autoComplete="off"
                                            />
                                        </div>
                                        {errorEndDate && (<small className="error_medotory">{errorEndDate}</small>)}
                                    </Form.Group>
                                </div>
                                <div className="col-md-3" >
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Upload Image<span className="mendatory_star">*</span></Form.Label>
                                        {NotificationState?.UploadedImage === "" ? (<div className="uploaded_image">
                                            <label className="btn" id="upload_image_btn">
                                                <input type="file" name="upload" id="fileInput" onChange={(e) => UploadImage(e)} accept=".jpg, .jpeg, .png" />
                                                <img src={UploadFileIcon} alt="Upload" />
                                                Upload Image
                                            </label>
                                            {LoaderFile && (<Spinner />)}
                                        </div>) : (<div className="image_upload_notifications_cmn">
                                            {NotificationState?.UploadedImageName}
                                            <img 
                                                src={DeleteIcon} 
                                                className="delete_btn" 
                                                onClick={() => {
                                                    setNotificationState({
                                                        ...NotificationState,
                                                        UploadedImage: "",
                                                        UploadedImageName: "",
                                                    });
                                                    CheckValid("", { type: 'NotificationUploadedImage', error: seterrorUploadedImage });
                                                }} 
                                                alt="edit" 
                                            /> 
                                        </div>)}
                                        {errorUploadedImage && (<small className="error_medotory">{errorUploadedImage}</small>)}
                                    </Form.Group>
                                </div>
                                <div className="col-md-3">
                                    <CommonToggle
                                        isBadgeAllow={true}
                                        badgeTitle={"active_inactive"}
                                        valueToggle={NotificationState?.Status}
                                        setValueToggle={(e) => setNotificationState({...NotificationState, Status: !NotificationState?.Status})}
                                        name={"Status"}
                                    />
                                </div>
                            </div>
                        </div>
                        {NotificationState?.StartDate && NotificationState?.EndDate && (<React.Fragment>
                            <div className="divider_forms">
                                <Form.Group className="mb-3" >
                                    <Form.Label>Notification Frequency<span className="mendatory_star">*</span></Form.Label>
                                    <div className="custome_radio_button_wraps">
                                        {FrequencyState && FrequencyState.filter((freq) => {
                                            const { StartDate, EndDate } = NotificationState;
                                            if(StartDate !== "" && EndDate !== "") {
                                                const rangeInDays = Math.ceil((EndDate - StartDate) / (1000 * 60 * 60 * 24));
                                                if (rangeInDays <= 1) {
                                                    return freq.frequency_name === "Daily" || freq.frequency_name === "Custom";
                                                } else if (rangeInDays <= 7) {
                                                    return (
                                                        freq.frequency_name === "Daily" ||
                                                        freq.frequency_name === "Weekly" ||
                                                        freq.frequency_name === "Custom"
                                                    );
                                                } else if (rangeInDays <= 30) {
                                                    return (
                                                        freq.frequency_name === "Daily" ||
                                                        freq.frequency_name === "Weekly" ||
                                                        freq.frequency_name === "Monthly" ||
                                                        freq.frequency_name === "Custom"
                                                    );
                                                } else if (rangeInDays >= 90) {
                                                    return (
                                                        freq.frequency_name === "Daily" ||
                                                        freq.frequency_name === "Weekly" ||
                                                        freq.frequency_name === "Monthly" ||
                                                        freq.frequency_name === "Quarterly" ||
                                                        freq.frequency_name === "Custom"
                                                    );
                                                } else {
                                                    return (
                                                        freq.frequency_name === "Daily" ||
                                                        freq.frequency_name === "Weekly" ||
                                                        freq.frequency_name === "Monthly" ||
                                                        freq.frequency_name === "Custom"
                                                    );
                                                };
                                            };
                                        })?.map((item, index) => {
                                            return (<React.Fragment key={index}>
                                            <div className="form-check">
                                                <input
                                                    type="radio"
                                                    className="form-check-input"
                                                    id={`frequency_${item.frequency_id}`}
                                                    name="frequency"
                                                    value={item.frequency_name}
                                                    checked={item.isChecked}
                                                    onChange={() => {
                                                        const updatedFrequency = FrequencyState.map((freq) =>
                                                            freq.frequency_id === item.frequency_id
                                                                ? { ...freq, isChecked: true }
                                                                : { 
                                                                    ...freq, 
                                                                    isChecked: false, 
                                                                    frequency_attempts: 1, 
                                                                    frequency_times: [{ id: 1, time: "" }], 
                                                                    frequency_dates: [{ id: 1, date: "" }], 
                                                                    frequency_days: freq.frequency_name === "Weekly"
                                                                        ? [ 
                                                                            { day_name: "Monday", short_day_name: "Mon", isChecked: false },
                                                                            { day_name: "Tuesday", short_day_name: "Tue", isChecked: false },
                                                                            { day_name: "Wednesday", short_day_name: "Wed", isChecked: false },
                                                                            { day_name: "Thursday", short_day_name: "Thu", isChecked: false },
                                                                            { day_name: "Friday", short_day_name: "Fri", isChecked: false },
                                                                            { day_name: "Saturday", short_day_name: "Sat", isChecked: false },
                                                                            { day_name: "Sunday", short_day_name: "Sun", isChecked: false },
                                                                        ] : [] 
                                                                }
                                                        );
                                                        setFrequencyState(updatedFrequency);
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor={`frequency_${item.frequency_id}`}>
                                                    {item.frequency_name}
                                                    {item?.isChecked && (<Form.Control
                                                        type="number"
                                                        className="form-control frequency_attempts inputBoxs"
                                                        value={item?.frequency_attempts}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(/^0/, "");
                                                            if (value <= 20) {
                                                                onChangeUpdatedFrequency(item.frequency_id, value);
                                                            }
                                                        }}
                                                        onKeyDown={(e) => {
                                                            EmptySpaceFieldValid(e);
                                                            exceptThisCostSymbols.includes(e.key) && e.preventDefault();
                                                        }}
                                                        placeholder="Enter Attempts (Max 20)"
                                                    />)} 
                                                </label>
                                            </div>
                                            {item?.isChecked && (<div className="custom_frequency">
                                                {item?.day_month_isAllow && (<div className="row">   
                                                    <div className="col-md-4 custom_frequency_dates custom_date_pickers" style={{ marginBottom: "16px" }}>
                                                        <DatePicker
                                                            selected={item.day_of_month ? moment(item.day_of_month, "DD").toDate() : null}
                                                            className="form-control"
                                                            onChange={(e) => {
                                                                const updatedFrequency = FrequencyState.map((freq) =>
                                                                    freq.frequency_id === item.frequency_id
                                                                        ? {
                                                                            ...freq,
                                                                            day_of_month: e ? moment(e).format("DD") : null,
                                                                        }
                                                                        : freq
                                                                );
                                                                setFrequencyState(updatedFrequency);
                                                            }}
                                                            dateFormat="dd"
                                                            placeholderText="Select Day of Month"
                                                            isClearable={true}
                                                        />
                                                    </div>
                                                </div>)}
                                                {item.frequency_name === "Weekly" && (<div className="row">
                                                    <div className="col-md-4 custom_frequency_days">
                                                        {item?.frequency_days?.map((day, dayIndex) => (
                                                            <div key={dayIndex} className="form-group form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    id={`day_${dayIndex}`}
                                                                    checked={day.isChecked}
                                                                    onChange={() => {
                                                                        const updatedFrequency = FrequencyState.map((freq) =>
                                                                            freq.frequency_id === item.frequency_id
                                                                                ? {
                                                                                    ...freq,
                                                                                    frequency_days: freq.frequency_days.map((d, dIndex) =>
                                                                                        dIndex === dayIndex ? { ...d, isChecked: !d.isChecked } : d
                                                                                    ),
                                                                                }
                                                                                : freq
                                                                        );
                                                                        setFrequencyState(updatedFrequency);
                                                                    }}
                                                                />
                                                                <label className="form-check-label" htmlFor={`day_${dayIndex}`}>
                                                                    {day.day_name}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>)}
                                                
                                                {item?.date_isAllow && (<div className="row">   
                                                    <div className="col-md-4 custom_frequency_dates">
                                                        {item?.frequency_dates?.map((date, dateIndex) => (
                                                            <div key={dateIndex} className="form-check">
                                                                {item?.frequency_name === "Quarterly" ? (<DatePicker
                                                                    selected={date.date}
                                                                    className="form-control"
                                                                    onChange={(e) => {
                                                                        const updatedFrequency = FrequencyState.map((freq) =>
                                                                            freq.frequency_id === item.frequency_id
                                                                                ? {
                                                                                    ...freq,
                                                                                    frequency_dates: freq.frequency_dates.map((d, dIndex) =>
                                                                                        dIndex === dateIndex ? { ...d, date: e } : d
                                                                                    ),
                                                                                }
                                                                                : freq
                                                                        );
                                                                        setFrequencyState(updatedFrequency);
                                                                    }}
                                                                    minDate={NotificationState?.StartDate}
                                                                    maxDate={
                                                                        NotificationState?.StartDate
                                                                            ? new Date(
                                                                                  NotificationState?.StartDate.getTime() +
                                                                                  90 * 24 * 60 * 60 * 1000
                                                                              )
                                                                            : NotificationState?.EndDate
                                                                    }
                                                                    dateFormat="dd/MM/yyyy"
                                                                    placeholderText="Select Date"
                                                                    isClearable={date.date ? true : false}
                                                                    excludeDates={item.frequency_dates
                                                                        .filter((_, dIndex) => dIndex !== dateIndex)
                                                                        .map((d) => d.date)}
                                                                />) : (<DatePicker
                                                                    selected={date.date}
                                                                    className="form-control"
                                                                    onChange={(e) => {
                                                                        const updatedFrequency = FrequencyState.map((freq) =>
                                                                            freq.frequency_id === item.frequency_id
                                                                                ? {
                                                                                    ...freq,
                                                                                    frequency_dates: freq.frequency_dates.map((d, dIndex) =>
                                                                                        dIndex === dateIndex ? { ...d, date: e } : d
                                                                                    ),
                                                                                }
                                                                                : freq
                                                                        );
                                                                        setFrequencyState(updatedFrequency);
                                                                    }}
                                                                    minDate={today}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    placeholderText="Select Date"
                                                                    isClearable={date.date ? true : false}
                                                                    excludeDates={item.frequency_dates
                                                                        .filter((_, dIndex) => dIndex !== dateIndex)
                                                                        .map((d) => d.date)}
                                                                />)}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>)}
                                                {item?.times_isAllow && (<div className="row">
                                                    <div className="col-md-4 custom_frequency_time">
                                                        {item?.frequency_times?.map((time, timeIndex, timeArray) => {
                                                            const timeOptions = [
                                                                "01:00", "01:15", "01:30", "01:45",
                                                                "02:00", "02:15", "02:30", "02:45",
                                                                "03:00", "03:15", "03:30", "03:45",
                                                                "04:00", "04:15", "04:30", "04:45",
                                                                "05:00", "05:15", "05:30", "05:45",
                                                                "06:00", "06:15", "06:30", "06:45",
                                                                "07:00", "07:15", "07:30", "07:45",
                                                                "08:00", "08:15", "08:30", "08:45",
                                                                "09:00", "09:15", "09:30", "09:45",
                                                                "10:00", "10:15", "10:30", "10:45",
                                                                "11:00", "11:15", "11:30", "11:45",
                                                                "12:00", "12:15", "12:30", "12:45",
                                                                "13:00", "13:15", "13:30", "13:45",
                                                                "14:00", "14:15", "14:30", "14:45",
                                                                "15:00", "15:15", "15:30", "15:45",
                                                                "16:00", "16:15", "16:30", "16:45",
                                                                "17:00", "17:15", "17:30", "17:45",
                                                                "18:00", "18:15", "18:30", "18:45",
                                                                "19:00", "19:15", "19:30", "19:45",
                                                                "20:00", "20:15", "20:30", "20:45",
                                                                "21:00", "21:15", "21:30", "21:45",
                                                                "22:00", "22:15", "22:30", "22:45",
                                                                "23:00", "23:15", "23:30", "23:45",
                                                                "24:00"
                                                            ];
                                                              
                                                            const disabledTimes = timeArray?.filter((elm) => elm?.time !== "")?.map((elm) => elm?.time);
                                                            return(<div key={timeIndex} className="form-check">
                                                                <select
                                                                    className="form-control"
                                                                    value={time.time}
                                                                    onChange={(e) => {
                                                                        const updatedFrequency = FrequencyState.map((freq) =>
                                                                            freq.frequency_id === item.frequency_id
                                                                                ? {
                                                                                      ...freq,
                                                                                      frequency_times: freq.frequency_times.map((t, tIndex) =>
                                                                                          tIndex === timeIndex ? { ...t, time: e.target.value } : t
                                                                                      ),
                                                                                  }
                                                                                : freq
                                                                        );
                                                                        setFrequencyState(updatedFrequency);
                                                                    }}
                                                                >
                                                                    <option value="">Select Time</option>
                                                                    {timeOptions && timeOptions?.map((timeOption, index) => {
                                                                        return (<option 
                                                                            key={index} 
                                                                            value={timeOption}
                                                                            disabled={disabledTimes?.includes(timeOption) && time?.time !== timeOption}
                                                                        >
                                                                            {timeOption}
                                                                        </option>)
                                                                    })}
                                                                </select>
                                                            </div>)
                                                        })}
                                                    </div>
                                                </div>)}
                                            </div>)}
                                        </React.Fragment>);
                                        })}
                                    </div>
                                    {errorNotificationFrequency && (<small className="error_medotory">{errorNotificationFrequency}</small>)}
                                </Form.Group>
                            </div>
                            <div className="col-md-12">
                                <button 
                                    className="btn formbtn" 
                                    style={{ width: "auto" }} 
                                    onClick={() => CreateNotificationsCMS()} 
                                    variant="primary" 
                                    disabled={ClearFormSet?.action === 200 && (ClearFormSet?.url === "add_cms_notification" || ClearFormSet?.url === "update_cms_notification")}
                                >
                                    Submit
                                </button>
                            </div>
                        </React.Fragment>)}
                    </React.Fragment>)}
                </div>
            </CommonScrollBar>
        </div>
    </section>)
}

export default CreateNotificationAndCMS;